import { render, staticRenderFns } from "./DiscountCreate.vue?vue&type=template&id=56539100"
import script from "./DiscountCreate.vue?vue&type=script&lang=js"
export * from "./DiscountCreate.vue?vue&type=script&lang=js"
import style0 from "./DiscountCreate.vue?vue&type=style&index=0&id=56539100&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports